module.exports = __webpack_public_path__ + "static/media/faq-desk-1920x720.bbf0a334.jpg";